import { TLibraryActions } from './library.action';
import { LibraryActionType, TLibraryState } from './library.models';

export const initialLibraryState: TLibraryState = {
  methodsListingInfo: null,
  obListingInfo: null,
};

export function libraryReducer(state = initialLibraryState, action: TLibraryActions): TLibraryState {
  switch (action.type) {
    case LibraryActionType.FetchAllMethodsSuccess:
      return { ...state, methodsListingInfo: action.res };

    case LibraryActionType.FetchAllOBsSuccess:
      return { ...state, obListingInfo: action.res };

    default:
      return state;
  }
}
